import { Accordion, Stack, Text } from "basis";
import { Question } from "./Question";

function Payments({ initiallyOpen }) {
  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>Payments</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question
            title="Can I make a payment in the LSC?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              In Australia the Latitude Service Centre has the capability to
              make direct transfer payments using your BSB and Account Number.
              This feature is not currently available in New Zealand.
            </Text>
          </Question>
          <Question
            title="Can I make a payment in the LSC?"
            productType="credit-card"
            region="NZ"
          >
            <Text>
              The ability to make a payment on the Latitude Service Centre is
              not currently available in New Zealand. Head to our Payment
              options to find a convenient way to make your payment.
            </Text>
          </Question>
          <Question
            title="When should I pay my account to ensure it's processed by the due date?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              To ensure your payment is received by the due date, please pay by
              your preferred payment method by the due date if it falls on a
              business day or last business day before your due date. Payments
              made before 3pm AEST on business days will be processed on the
              same business day. Please allow up to three business days for the
              payment to show in your transaction history.
            </Text>
          </Question>
          <Question
            title="When should I pay my account to ensure it's processed by the due date?"
            productType="credit-card"
            region="NZ"
          >
            <Text>
              To ensure your payment is received by the due date please pay by
              your preferred payment method by the due date if it falls on a
              business day or last business day before your due date. Payments
              made before 3pm NZST on business days will be processed on the
              same business day. Please allow up to three business days for the
              payment to show in your transaction history.
            </Text>
          </Question>
          <Question
            title="How many days do I need to wait before making another Direct Transfer payment?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              It can take up to five days for your payment to process. You will
              be able to make another direct transfer payment in five days.
            </Text>
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}

export { Payments };
